import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';
import { prepareFilters, segmentFields } from '../helpers';

export const prepareDataTable = data => {
  const dataTable = [];
  const mappedData = data.map(element => {
    return { ...element, selected: false };
  });

  mappedData.forEach((item, index) => {
    const el = {
      ...item.regular_user,
      key: item.user.uuid + `_${index}`,
      creator: {
        uuid: item.user.uuid,
        avatar_url: item.user.avatar_url,
        avatar_params: item.user.avatar_params,
        name: item.user.name,
        social_accounts: item.user.social_accounts,
        ...segmentFields(item.signals)
      },
      links: item.filtered_active_links,
      clicks: item.filtered_clicks,
      sales: item.filtered_gmv,
      sales_per_click: item.filtered_gmv_per_click,
      sales_per_link: item.filtered_gmv_per_link,
      conversion_rate: item.filtered_conversion_rate,
      campaigns: item.user_campaigns,
      groups: item.user_groups,
      select: { id: item.user.uuid, value: false },
      operations: {
        ...item.user,
        key: item.user.uuid + `_${index}`
      }
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getPerformanceCreators({ payload: { signal, filters, searchQ, curr_page, onSuccess } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.analytics.users,
      data: {
        ...prepareFilters(filters),
        include_comparison: true,
        q: searchQ,
        page: curr_page
      },
      signal
    });

    const preparedData = {
      next: data.next,
      previous: data.previous,
      count: data.count,
      message: data.message,
      dataTable: prepareDataTable(data.results),
      apiFilters: data.filters
      // campaign_modifiers: data.campaign_modifiers
    };

    onSuccess && onSuccess(data);

    yield put(actions.getPerformanceCreatorsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPerformanceCreatorsFailed,
      endpoint: api.analytics.users.url
    });
  }
}

export const getPerformanceCreatorsSaga = takeEvery(types.GET_PERFORMANCE_CREATORS_REQUEST, getPerformanceCreators);


